/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { FormattedMessage } from "react-intl"
import { Box, Stack, Tile, Typography } from "@carrotfertility/carotene-core"

export const BalanceTile = ({ title, value }: { title: React.ReactNode; value: React.ReactNode }) => (
  <Tile variant="primary" color="primary" component="dl" sx={{ flex: 1, minInlineSize: "12.5rem", margin: 0 }}>
    <Typography component="dt" variant="h5">
      {title}
    </Typography>
    <Typography
      component="dd"
      variant="h4"
      sx={(theme) => ({ marginInlineStart: 0, marginBlockStart: theme.tokens.spacing.sm })}
    >
      {value}
    </Typography>
  </Tile>
)

export const BalanceTileRow = ({ children }: React.PropsWithChildren) => (
  <Stack direction="row" sx={(theme) => ({ flexWrap: "wrap", gap: theme.tokens.spacing.md })}>
    {children}
  </Stack>
)

export const BalanceSection = ({
  title,
  description,
  titleVariant = "h2",
  gutterBottom = true,
  children
}: React.PropsWithChildren<{
  title: React.ReactNode
  description: React.ReactNode
  titleVariant?: "h2" | "h3"
  gutterBottom?: boolean
}>) => (
  <Box sx={(theme) => ({ paddingBlockEnd: gutterBottom ? theme.tokens.spacing.xxl : 0 })}>
    <Typography variant={titleVariant} sx={(theme) => ({ paddingBlockEnd: theme.tokens.spacing.xs })}>
      {title}
    </Typography>
    <Typography
      variant="body1"
      sx={(theme) => ({ color: theme.palette.text.secondary, paddingBlockEnd: theme.tokens.spacing.md })}
    >
      {description}
    </Typography>
    <BalanceTileRow>{children}</BalanceTileRow>
  </Box>
)

const CREDITS_PER_CARROT_CYCLE = 12

// Credits are sold in whole Carrot Cycles; skip the sentence if a plan isn't.
export const CarrotCycles = ({ creditLifetimeMax }: { creditLifetimeMax: number }) => {
  const cycles = creditLifetimeMax / CREDITS_PER_CARROT_CYCLE
  if (!Number.isInteger(cycles) || cycles < 1) return null
  return (
    <>
      <FormattedMessage
        defaultMessage="{cycles, plural, one {Your benefit includes # Carrot Cycle ({credits} credits).} other {Your benefit includes # Carrot Cycles ({credits} credits each).}}"
        values={{ cycles, credits: CREDITS_PER_CARROT_CYCLE }}
      />{" "}
    </>
  )
}
